import styled from 'styled-components'

export const AbrechnungRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`

export const AbrechnungMonth = styled.span`
  color: #333;
  font-size: 14px;
`

export const AbrechnungAmount = styled.span`
  color: #333;
  font-size: 14px;
  margin-right: 20px;
`
